var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'MealSku', params: { sku: _vm.sku }}}},[_vm._v(" "+_vm._s(_vm.sku ? ("" + _vm.sku) : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }